import $ from "jquery";
// import Swiper JS
import Swiper, { Navigation, Pagination, Scrollbar, EffectFade } from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Scrollbar, EffectFade]);

$('.slider_f41b').each(function() {
  var $this = $(this);
  var $next = $this.find('.slider_f41b__next');
  var $prev = $this.find('.slider_f41b__prev');

  var slider = new Swiper($this[0], {
    slidesPerView: 1,
    effect: 'fade',
    speed: 400,
    fadeEffect: { crossFade: true },
    navigation: {
      nextEl: $next[0],
      prevEl: $prev[0],
    }
  });
});